import { render } from "./StoreMonthlySalesTargetModal.vue?vue&type=template&id=6602696b"
import script from "./StoreMonthlySalesTargetModal.vue?vue&type=script&lang=js"
export * from "./StoreMonthlySalesTargetModal.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./StoreMonthlySalesTargetModal.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_9f68edcb%2Fpackages%2Finsurer%2Fsrc%2Fcomponents%2Fstores%2FStoreMonthlySalesTargetModal.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__